module.exports = __webpack_public_path__ + "static/media/bannerImg.903f5d6b.png";